import { defineComponent as _defineComponent } from 'vue'
import { onMounted, reactive, ref } from "vue"
import type { Ref, Component } from "vue"

// Classes
import { ClubAdvantage } from "./classes/ClubAdvantage"

// Components
import ClubServiceCard from "./components/ClubServiceCard.vue"
import InfantClubContent from "./components/InfantClubContent.vue"

// Popup Components
import DefaultPopUp from "./components/DefaultPopUp.vue"
import InfantClubPopUp from "./components/InfantClubPopUp.vue"

// Icons
import RestaurationIcon from "./components/RestaurationIcon.vue"
import InfantClubIcon from "./components/InfantClubIcon.vue"
import AnimationIcon from "./components/AnimationIcon.vue"
import wellBeingIcon from "./components/wellBeingIcon.vue"

// Builders
import buildInfantClubs from "./builder/buildInfantClubs"

// State
import state from "./state/state"

// Data
interface Data {
	advantages: ClubAdvantage[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const data: Data = reactive({
	advantages: [],
})

// Methods
const addAdvantages = (): void => {
	try {
		if (window!.lihe.restaurantDescription) {
			data.advantages.push(
				new ClubAdvantage(
					"restauration",
					RestaurationIcon,
					window.content.liheDesc_includeRestaurationSegment,
					false,
					window.lihe.restaurantDescription,
					"",
					undefined,
					DefaultPopUp
				)
			)
		}

		if (window!.lihe.clubs && window.lihe.clubs.length) {
			buildInfantClubs()
			if (!state.hideClubs) {
				data.advantages.push(
					new ClubAdvantage(
						"InfantClub",
						InfantClubIcon,
						window.content.kids_club,
						false,
						undefined,
						undefined,
						InfantClubContent,
						InfantClubPopUp
					)
				)
			}
		}

		if (window!.lihe.animation) {
			if (!window.lihe.animation.yourAnim)
				throw new Error("animation missing content in addAdvantages")
			data.advantages.push(
				new ClubAdvantage(
					"animation",
					AnimationIcon,
					window.content.entertainment,
					false,
					window.lihe.animation.yourAnim,
					undefined,
					undefined,
					DefaultPopUp
				)
			)
		}

		// TODO, check field name once the welness field is added to the backoffice
		if (window!.lihe.wellBeing) {
			data.advantages.push(
				new ClubAdvantage(
					"wellBeing",
					wellBeingIcon,
					window.content.wellness,
					false,
					window.lihe.wellBeing,
					undefined,
					undefined,
					DefaultPopUp
				)
			)
		}
	} catch (e) {
		hideAdvantagesTitle()
	}
}

const hideAdvantagesTitle = (): void => {
	const clubsTitle: HTMLElement | null =
		document.querySelector("[data-clubstitle]")
	if (!data.advantages.length && clubsTitle) {
		clubsTitle.style.display = "none"
	}
}

onMounted(() => {
	addAdvantages()
	// Hide the title if no results
})

return { __sfc: true,data, addAdvantages, hideAdvantagesTitle, ClubServiceCard }
}

})